export enum VeryhighToVerylow {
	VERY_HIGH = 'VERY_HIGH',
	HIGH = 'HIGH',
	MEDIUM = 'MEDIUM',
	LOW = 'LOW',
	VERY_LOW = 'VERY_LOW',
}
